<template>
  <div class="app-activation-auto-top-up-wrapper">
    <div v-if="!isAnnualTarrif" class="text"><slot name="txtBeforeAutoTopUp"></slot></div>
    <div v-if="isAnnualTarrif" class="text"><slot name="txtBeforeAutoTopUpAnnual"></slot></div>
    <b-form-checkbox-group v-model="selectedTopUpTypes_">
      <b-form-group label="Single Top Up" label-class="visually-hidden">
        <b-col cols="12" class="single-top-up-wrapper" v-if="showSingleTopUp">
          <b-form-checkbox value="single" @change="change($event, 'single')">
            <EnterSingleTopUp
              :amounts="possibleSingleTopUpAmounts.amount"
              :defaultAmount="defaultValueSingleTopUp"
              :single-top-up.sync="singleTopUp_"
            >
              <template v-for="slot in possibleChildSlotsFor('SingleTopUp')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </EnterSingleTopUp>
          </b-form-checkbox>
          <b-alert
            :show="alertSingleTopUp"
            dismissible
          >
            <slot name="txtSingleTopUpAlert">Sollte Dein Guthaben nicht ausreichen, wird Dein Tarif ruhend gestellt</slot>
          </b-alert>
        </b-col>
      </b-form-group>
      <b-form-group label="Auto Top Up" label-class="visually-hidden">
        <b-col cols="12" class="auto-top-up-wrapper" v-if="showAutoTopUp">
          <b-form-checkbox value="auto" @change="change($event, 'auto')">
            <slot name="txtAutoBeforeRadio"></slot>
            <b-form-radio-group  required
                                 class="top-up-group"
                                 v-model="splittedTopUp"
            >
              <EnterAutoTopUp
                :top-up="autoTopUp_"
                :trigger.sync="autoTopUp_.trigger"
                :amount.sync="autoTopUp_.amount"
                :monthly-value="monthlyValue"
                :inside-activation="true"
              >
                <template v-for="slot in possibleChildSlotsFor('AutoTopUp')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
              </EnterAutoTopUp>
            </b-form-radio-group>
          </b-form-checkbox>
          <b-alert
            :show="alertAutoTopUp"
            dismissible
          >
            <slot name="txtAutoTopUpAlert">Sollte Dein Guthaben nicht ausreichen, wird Dein Tarif ruhend gestellt</slot>
          </b-alert>
        </b-col>
      </b-form-group>
      <b-form-group label="Without Auto Top Up" label-class="visually-hidden">
        <b-col cols="12" class="without-auto-wrapper">
          <b-form-checkbox value="without" @change="change($event, 'without')">
            <slot name="lblWithoutAuto">Weiter ohne automatische Aufladung</slot>
          </b-form-checkbox>
        </b-col>
      </b-form-group>
    </b-form-checkbox-group>
  </div>
</template>

<script>
import EnterSingleTopUp from '@/components/process/LIDL/Activation/TopUp/EnterSingleTopUp.vue'
import EnterAutoTopUp from '@/components/process/LIDL/Activation/TopUp/EnterAutoTopUp.vue'
import syncProperty from '@/mixins/syncProperty'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
export default {
  name: 'EnterAutoSingleTopUp',
  mixins: [
    syncProperty('autoTopUp', 'autoTopUp_'),
    syncProperty('singleTopUp', 'singleTopUp_'),
    syncProperty('selectedTopUpTypes', 'selectedTopUpTypes_'),
    transaction('activation'),
    slotProxy()
  ],
  watch: {
    // automatically select the checkbox for single or auto topup if an deeper option is selected
    singleTopUp_: {
      immediate: true,
      handler: function (value, old) {
        if (this.selectedTopUpTypes.includes('single') === false && old !== undefined) {
          this.change([...this.selectedTopUpTypes, 'single'], 'single')
        }
      }
    },
    autoTopUp_: {
      deep: true,
      handler: function (value) {
        if (value.type === 'monthly' && value.trigger === null) {
          value.trigger = this.monthlyValue[0]
        }
        if (this.selectedTopUpTypes.includes('auto') === false) {
          this.change([...this.selectedTopUpTypes, 'auto'], 'auto')
        }
      }
    }
  },
  methods: {
    change (newValue, changedItem) {
      if (newValue.includes('without') && newValue.length > 1) {
        // invalid!, without + 1 other option
        if (changedItem === 'without') {
          // last change was clicking without -> all other values must be deselected
          this.selectedTopUpTypes_ = ['without']
        } else {
          // clicked anoter, without must be removed
          this.selectedTopUpTypes_ = [
            ...newValue.filter(item => item !== 'without')
          ]
        }
      } else if (newValue.length === 0) {
        // empty is not good, select all available types
        if (changedItem === 'without') {
          this.selectedTopUpTypes_ = [
            'auto',
            ...(this.showSingleTopUp ? ['single'] : [])
          ]
        } else {
          this.selectedTopUpTypes_ = ['without']
        }
      } else {
        this.selectedTopUpTypes_ = newValue
      }
    }
  },
  computed: {
    isAnnualTarrif: function () {
      return this.selectedTariff?.tariffExtra?.type === 'year'
    },
    alertSingleTopUp: function () {
      return !this.selectedTopUpTypes.includes('single')
    },
    alertAutoTopUp: function () {
      return !this.selectedTopUpTypes.includes('auto')
    },
    defaultValueSingleTopUp: function () {
      if (this.selectedTariff?.tariffExtra?.type === 'year') {
        return this.selectedTariff?.tariffExtra?.singleTopUp
      }
      return this.singleTopUp_ || this.possibleSingleTopUpAmounts.default
    },
    splittedTopUp: {
      get: function () {
        if (this.autoTopUp_.type === 'monthly') {
          if (this.autoTopUp_.trigger === null) {
            return {
              type: this.autoTopUp_.type,
              trigger: this.monthlyValue[0]
            }
          }
          return {
            type: this.autoTopUp_.type,
            trigger: this.autoTopUp_.trigger
          }
        }
        return {
          type: this.autoTopUp_.type
        }
      },
      set: function (value) {
        this.autoTopUp_.type = value.type
        if (value.type === 'withoutAuto') {
          this.autoTopUp_.trigger = null
          this.autoTopUp_.amount = null
        }
        if (value.type === 'monthly') {
          this.autoTopUp_.trigger = value.trigger
        }
      }
    }
  },
  components: { EnterAutoTopUp, EnterSingleTopUp },
  props: ['monthlyValue', 'possibleSingleTopUpAmounts', 'showSingleTopUp', 'showAutoTopUp', 'selectedTariff']
}
</script>
